import Cookies from "js-cookie";

export function initializeCookies() {
  if (!Cookies.get("cookies_acceptance")) {
    $(".ct-popover-cookies").removeClass("d-none");
  } else {
    $(".btn-cookies").removeClass("d-none");
  }

  if (Cookies.get("mtm_consent_removed")) {
    setCookieAcceptance(false);
  } else {
    setCookieAcceptance(true);
  }

  function setCookieAcceptance(acceptance) {
    if (acceptance) {
      $("#cookies-acceptance").prop("checked", true);
      $(".cookies-description-refusal").addClass("d-none");
      $(".cookies-description-acceptance").removeClass("d-none");
      $("#cookies-acceptance + label").html(
        $("#cookies-acceptance + label").data("acceptance")
      );
    } else {
      $("#cookies-acceptance").prop("checked", false);
      $(".cookies-description-acceptance").addClass("d-none");
      $(".cookies-description-refusal").removeClass("d-none");
      $("#cookies-acceptance + label").html(
        $("#cookies-acceptance + label").data("refusal")
      );
    }
  }

  $("#cookies-acceptance").click(function () {
    if ($(this).is(":checked")) {
      setCookieAcceptance(true);
      _paq.push(["forgetUserOptOut"]);
      Cookies.set("cookies_acceptance", true, { expires: 30 });
    } else {
      setCookieAcceptance(false);
      _paq.push(["optUserOut"]);
      Cookies.set("cookies_acceptance", false, { expires: 30 });
    }
  });

  $(".ct-popover-cookies__link").click(function (e) {
    $(".ct-popover-cookies").addClass("d-none");
    e.preventDefault();
    if ($(this).hasClass("ct-popover-cookies__link-approve")) {
      setCookieAcceptance(true);
      _paq.push(["forgetUserOptOut"]);
      Cookies.set("cookies_acceptance", true, { expires: 30 });
    } else {
      setCookieAcceptance(false);
      _paq.push(["optUserOut"]);
      Cookies.set("cookies_acceptance", false, { expires: 30 });
    }
  });

  $(".ct-popover__close").click(function (e) {
    e.preventDefault();
    $(".ct-popover-cookies").addClass("d-none");
  });

  $('.btn-cookies').click(function(e) {
    e.preventDefault();
    $(".ct-popover-cookies").removeClass("d-none");
  });
}
